<template>
  <div>
    <Hero />
    <AppTeaser />
    <SbuTeaser />
    <Weiterbildung />
    <Downlaods />
    <Contact v-if="$store.compShowByDate" />
  </div>
</template>

<script>
import Hero from './Hero.vue'
import AppTeaser from './AppTeaser.vue'
import SbuTeaser from './SbuTeaser.vue'
import Weiterbildung from './Weiterbildung.vue'
import Downlaods from './Downloads.vue'
import Contact from './Contact.vue'

export default {
  name: 'HomeView',
  components: {
    Hero,
    AppTeaser,
    SbuTeaser,
    Weiterbildung,
    Downlaods,
    Contact
  },
  async mounted() {
    await this.$sleep(500)
    if (this.$route.query.goto) {
      this.$scrollTo('#'+this.$route.query.goto)
    }
  }
}
</script>